import React from 'react';
import s from './style.css';
const CircleProgress = ({ progress = 0, strokeWidth = 4, size = 100, opacity = 1 }) => {
    const radius = (size - strokeWidth * 2) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - progress * circumference;
    return (React.createElement("svg", { width: size, height: size, style: { opacity } },
        React.createElement("circle", { cx: size / 2, cy: size / 2, r: radius, className: s.circleBase, strokeWidth: strokeWidth, fill: 'none' }),
        React.createElement("circle", { cx: size / 2, cy: size / 2, r: radius, className: s.circleProgress, strokeWidth: strokeWidth, fill: 'none', strokeDasharray: circumference, strokeDashoffset: offset, transform: `rotate(-90 ${size / 2} ${size / 2})` })));
};
export default CircleProgress;
